import { memo } from 'react'
import { InputWithIcon } from 'components/ui/selects/InputWithIcon'
import { ISelectInputProps } from 'components/ui/selects/SelectInputTypes'
import { CustomerAccess } from 'schema'

export const SelectAddressInput = memo(function SelectAddressInput({
  placeholder,
  searchValue,
  onChange,
  desktopParentElement
}: ISelectInputProps<CustomerAccess>) {
  return (
    <>
      <InputWithIcon
        desktopParentElement={desktopParentElement}
        onChange={onChange}
        placeholder={placeholder}
        testId="customers-page--add-new-customer-form--company-address-input"
        value={searchValue}
      />
    </>
  )
})
